import React, {useState} from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Footer, Navbar } from '../../components';

//import text data
import webtexts from '../../assets/webtexts.json'

// import images
import {wide, square} from '../../assets'
import { ContactInfo } from '../Contact';

const Project = ({id}) => {
  function importAll(r) {
    let images ={};
    r.keys().forEach((item, index) => {images[item.replace('./','')] =r(item); });
    return images
  }

  const celesteImg = importAll(require.context('../../assets/images/projects/celeste', false, /\.(png|jpe?g|svg)$/));
  const hiveImg = importAll(require.context('../../assets/images/projects/hive', false, /\.(png|jpe?g|svg)$/));
  const jacksonImg = importAll(require.context('../../assets/images/projects/jackson', false, /\.(png|jpe?g|svg)$/));
  const twcImg = importAll(require.context('../../assets/images/projects/the-new-chapter', false, /\.(png|jpe?g|svg)$/));
  const vineImg = importAll(require.context('../../assets/images/projects/vine', false, /\.(png|jpe?g|svg)$/));
  const waterfrontImg = importAll(require.context('../../assets/images/projects/waterfront', false, /\.(png|jpe?g|svg)$/));
  const madronaImg = importAll(require.context('../../assets/images/projects/madrona', false, /\.(png|jpe?g|svg)$/));

  const projects = [
    {name: 'Celeste Residence', images: celesteImg, path: 'celeste-residence', id:'celeste'},
    {name: 'Hive II', images: hiveImg, path: 'hive', id: 'hive'},
    {name: "Jackson House", images: jacksonImg, path: 'jackson-house', id:'jackson'},
    {name: 'The New Chapter', images: twcImg, path: 'the-new-chapter', id:'tnc'},
    {name: 'Vine', images: vineImg, path: 'vine', id:'vine'},
    {name: 'Waterfront Eye Wear', images: waterfrontImg, path: 'waterfront-eye-wear', id:'waterfront'},
    {name: 'Madrona', images: madronaImg, path: 'madrona', id:'madrona'},
  ]

  const selectedProject = projects.find(project => project.id === id);
  const selectedProjectText = webtexts.projects.find(project => project.id === id)

  const text1 = selectedProjectText.text1;
  const text2 = selectedProjectText.text2;

  const [isFullScreen, setIsFullScreen] = useState(false);
  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };
  
  return (
    <Box
      sx={{

      }}
    >
      
      <Box
        sx={{
          justifyContent:'center',
          alignItems:'center',
          backgroundColor:'rgba(50, 50, 50, 0.5)',
        }}
      >
        <Navbar />
        
    <Box
      sx={{
        margin:'1rem',
        display:'flex',
        flexWrap: 'wrap',

      }}
    >
      {selectedProject.images && Object.values(selectedProject.images)[0] && (
        <Box
          sx={{
            width:'50%',
            // margin:'auto',
            display:'flex',
            flexWrap:'wrap',
            '@media (max-width: 768px)': {
              minWidth: '100%', // Adjust width for smaller screens
            },
          }}
        >
          <img 
            src={Object.values(selectedProject.images)[0]} 
            alt={selectedProject.name}
            style={{width: '100%', height:'auto', objectFit:'cover', cursor: 'pointer',}}
            onClick={toggleFullScreen}
           />
        </Box>
      ) }
      <Box
        sx={{
          width:'40%',
          margin:'auto',
          padding:'1rem',
          '@media (max-width: 768px)': {
            minWidth: '90%', // Adjust width for smaller screens
          },
        }}
      >
        <Typography
          sx={{
            fontSize:'2.5rem',
            fontFamily:"ITC Avant Garde Gothic",
            fontStyle:'normal',
            fontWeight:'1000',
            color:'#fefefe'
          }}
        >{selectedProject.name}</Typography>
        <Typography
          sx={{
            fontFamily:'Gotham',
            color:'#fefefe',
            fontSize:'1rem',
          }}
        ><br />{text1}</Typography>
        <Typography
          sx={{
            fontFamily:'Gotham',
            color:'#fefefe',
            fontSize:'1rem',
          }}
        ><br />{text2}</Typography>
        <Button
          variant='outlined'
          href='/projects'
          sx={{
            marginY:'1rem',
            border:'0',
            backgroundColor:'rgba(50, 50, 50, 0.9)',
            color:'#fefefe',
            fontStyle:'',
            '&hover':{
              color:'#000'
            }
          }}
        >Projects</Button>
      </Box>
    </Box>
     <Box
      sx={{
        display:'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      }}
     >
      {selectedProject.images && Object.values(selectedProject.images).map((image, index) =>(
        <Box
          key={index}
          sx={{
            maxWidth:'30%',
            margin: '1rem',
            minHeight: '30rem',
            '@media (max-width: 768px)': {
              minWidth: '90%', // Adjust width for smaller screens
              minHeight: '30rem', // Remove fixed height for smaller screens
            },
          }}
        >
          <img 
            src={image} 
            
            alt={`${selectedProject.name} ${index}`}
            style={{width:'100%',height:'100%', objectFit:'cover', cursor: 'pointer',}}
            onClick={toggleFullScreen}
          />
        </Box>
      ))}
     </Box>
     </Box>
      <ContactInfo />
     <Footer />
    </Box>
  );
};

export default Project;
